import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { FieldEditorV2Component } from '../../base-template-editor-v2/field-editor-v2/field-editor-v2.component';
import { InlineEditV2Directive } from '../../base-template-editor-v2/inline-edit/inline-edit-v2.directive';
import { BaseComponent } from '../../common/BaseComponent';
import { Helper } from '../../../../utils/helper';
import {
  OnlyIntroInitModel,
  OnlyIntroInitVariables,
  OnlyIntroModel,
  OnlyIntroVariables,
} from '../../../../models/email-template/only-intro.interface';

/**
 * Mockup-styled Only Intro block - a drop-in replacement for app-only-intro
 * in block-renderer-v2 (same [block]/[isPreview] inputs and outputs), so it
 * covers both the center-canvas summary (isPreview=true) and the
 * right-panel edit form (isPreview=false). Reuses the real, unmodified
 * app-field-editor-v2 and app-pin sub-components and the exact same
 * OnlyIntroVariables field name - only the surrounding layout is new.
 * Comments are reachable via the separate Comments tab (see
 * edit-block-comments-v2), same as Main Banner/Intro + CTA/Big Headline.
 */
@Component({
  selector: 'app-only-intro-v2',
  imports: [CommonModule, ReactiveFormsModule, FieldEditorV2Component, InlineEditV2Directive],
  templateUrl: './only-intro-v2.component.html',
  styleUrl: './only-intro-v2.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class OnlyIntroComponentV2 extends BaseComponent implements OnInit {
  @Input() block: OnlyIntroModel = new OnlyIntroInitModel();
  @Input() isPreview = false;
  @Input() disabled = false;

  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new OnlyIntroInitVariables();
    }
  }

  onlyIntroPlaceholder = 'Enter Intro Text';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId);
  }

  onChange(value: any, fieldName: keyof OnlyIntroVariables) {
    if (this.block.variables) {
      (this.block.variables as any)[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }
}
